import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import Button from '../../shared/Button';
import ResultBreakPointsSlider from '../ResultBreakPointsSlider';
import { UNITS } from '../../../constants/uom';
import styles from './styles.scss';


class ResultBreakPointsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      low: props.low,
      high: props.high
    };
    this.onChangeRange = this.onChangeRange.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  onChangeRange(range) {
    this.setState({
      low: range[0],
      high: range[1]
    });
  }

  onSave() {
    const {
      low,
      high
    } = this.state;
    const {
      changeBreakPoints,
      toggle
    } = this.props;
    changeBreakPoints(low, high);
    toggle();
  }

  onCancel() {
    const {
      low,
      high,
      toggle
    } = this.props;

    this.setState({
      low,
      high
    });

    toggle();
  }

  get minRadonValue() {
    return 0;
  }

  get maxRadonValue() {
    const { units } = this.props;

    if (units === UNITS.radon.pciL) {
      return 10;
    }
    if (units === UNITS.radon.bqM3) {
      return 400;
    }
  }

  get stepIncrement() {
    const { units } = this.props;

    if (units === UNITS.radon.pciL) {
      return 0.1;
    }
    if (units === UNITS.radon.bqM3) {
      return 10;
    }
  }

  get labelStepIncrement() {
    const { units } = this.props;

    if (units === UNITS.radon.pciL) {
      return 1;
    }
    if (units === UNITS.radon.bqM3) {
      return 50;
    }
  }

  render() {
    const {
      isOpen,
      toggle,
      units
    } = this.props;
    const {
      low,
      high
    } = this.state;

    return (
      <Modal
        isOpen={isOpen}
        toggle={toggle}
      >
        <ModalBody className={styles.modal.body}>
          <ResultBreakPointsSlider
            high={high}
            low={low}
            units={units}
            min={this.minRadonValue}
            max={this.maxRadonValue}
            step={this.stepIncrement}
            labelStep={this.labelStepIncrement}
            onChangeRange={this.onChangeRange}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            kind='primary'
            onClick={this.onCancel}>
            Cancel
          </Button>
          <Button
            kind='primary'
            onClick={this.onSave}>
            Save Changes
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

ResultBreakPointsModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  high: PropTypes.number,
  low: PropTypes.number,
  units: PropTypes.string,
  changeBreakPoints: PropTypes.func
};

export default ResultBreakPointsModal;


// WEBPACK FOOTER //
// src/components/reportManagement/ResultBreakPointsModal/index.jsx